const { ADD_TOASTR } = require('react-redux-toastr/src/constants');

/**
 * This is a special action that middleware could rewrite to
 * from an react-redux-toastr ADD action when toast muting is active
 */
export const ADD_MUTED_TOAST = 'ADD_MUTED_TOAST';

/**
 * This is to help rebrand the same constant used in react-redux-toastr
 * for our patterning
 */
export const ADD_TOAST = ADD_TOASTR;

export const DELETE_TOAST = 'DELETE_TOAST';
export const deleteRecentToast = (toast) => {
  return {
    type: DELETE_TOAST,
    toast
  };
};


// WEBPACK FOOTER //
// src/actions/toasts.js